import { DividerSectionElement } from "./DividerSectionElement";

export default DividerSectionElement;
